import create from "../create";
import { resumeProgress } from "./save-time";

export default async function (element, config) {
  const { mutedPreview, mutedOverlay } = config?.blockAttributes;
  const originalConfig = config;

  let player = await create({
    selector: element,
    config: {
      ...config,
      ...{
        // autoplay settings
        sticky_scroll: false,
        loop: { active: true },
        mutedAutoplay: true,
        muted: true,
        analytics: false,
        ajaxProgress: false,
        storage: {
          enabled: false,
        },
        captions: {
          active: mutedPreview?.captions,
          language: "auto",
          update: false,
        },
      },
    },
  });

  const $container = jQuery(player?.elements?.container);
  const $wrapper = $container.closest(".presto-player__wrapper");
  $wrapper.addClass("is-muted-overlay");
  const overlay = jQuery(
    `<div class="presto-player__muted-overlay">
      <div class="plyr__control plyr__control--overlaid" data-plyr="play" aria-label="Play">
        <svg id="plyr-play" viewBox="0 0 18 18">
          <path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"></path>
        </svg>
        <span class="plyr__sr-only">Play</span>
      </div>
    ${
      mutedOverlay?.enabled && mutedOverlay?.src
        ? `<div
        class="presto-player__overlay is-image"
        style="
          width: ${mutedOverlay?.width || 50}%;
          left: ${(mutedOverlay?.focalPoint?.x || 0.5) * 100}%;
          top: ${(mutedOverlay?.focalPoint?.y || 0.5) * 100}%;
        "
      >
        <img
          src="${mutedOverlay?.src}"
          style="transform:translateX(-50%) translateY(-50%)"
        />
      </div>`
        : ""
    }
    </div>`
  ).appendTo(jQuery(player?.elements?.container));

  // autoplay on mute
  player.on("ready", () => {
    player.muted = true;
    setTimeout(() => {
      player.restart();
      setTimeout(() => {
        player.play();
      }, 0);

      setTimeout(() => {
        player.toggleControls(false);
        if (mutedPreview?.captions) {
          player.toggleCaptions(true);
        }
      }, 0);
    }, 0);
  });

  // clicked, start video
  overlay.on("click", () => {
    overlay.remove();
    $wrapper.removeClass("is-muted-overlay");

    // restore originals
    player.config.sticky_scroll = originalConfig?.sticky_scroll;
    player.config.analytics = originalConfig?.analytics;
    player.config.ajaxProgress = originalConfig?.ajaxProgress;
    player.config.save_player_position = originalConfig?.save_player_position;
    player.config.mutedAutoplay = false;
    player.muted = false;
    player.loop = false;

    // restore to defaults
    player.toggleControls(true);
    player.toggleCaptions(false);

    setTimeout(() => {
      const resume = resumeProgress(player);

      if (!resume) {
        player.restart();
      }
    }, 0);
  });
}
